/**
 * QueryProvider - TanStack Query 配置组件
 * 在 App 根级别提供 QueryClient
 */

import { type ReactNode } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./query-client";

interface QueryProviderProps {
  children: ReactNode;
}

/**
 * 必须在 App 入口点渲染一次
 * 内部使用 Singleton 模式，重复渲染不影响
 */
export function QueryProvider({ children }: QueryProviderProps) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
